import { render, staticRenderFns } from "./RegistrationsFilters.vue?vue&type=template&id=6ff81b93&"
import script from "./RegistrationsFilters.vue?vue&type=script&lang=js&"
export * from "./RegistrationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff81b93')) {
      api.createRecord('6ff81b93', component.options)
    } else {
      api.reload('6ff81b93', component.options)
    }
    module.hot.accept("./RegistrationsFilters.vue?vue&type=template&id=6ff81b93&", function () {
      api.rerender('6ff81b93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/filters/RegistrationsFilters.vue"
export default component.exports